var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/array.js
// module id = ./node_modules/d3-scale/src/array.js
// module chunks = 1